import axios from "axios";
const token = localStorage.getItem('authToken');
console.log("token",token);
const baseURL = axios.create({
  baseURL: "https://select-proposal-api-b4e057f5ce9b.herokuapp.com",
  // baseURL: "http://localhost:3001",
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
  }
});

export default baseURL;
// select-proposal-api-b4e057f5ce9b.herokuapp.com
